import React from 'react'
import { RichText as PrismicRichText } from "prismic-reactjs"
import styled from "styled-components"

import { Element, rawHtmlCss } from "components/shared/base"
import {
  PrismicHomepageDataBodySingleColumnPrimary
} from "types/__generated__/gatsby-graphql"


export type SingleColumnProps = PrismicHomepageDataBodySingleColumnPrimary

const StyledSingleColumn = styled(Element)`
  ${rawHtmlCss}
`;

const SingleColumn: React.FC<SingleColumnProps> = ({
  background_color,
  eyebrow,
  text_color,
  wysiwyg
}): React.ReactElement | null => {
  if (!wysiwyg || !wysiwyg.richText) {
    return null
  }

  return (
    <StyledSingleColumn
      as="section"
      bg={background_color}
      color={text_color}
      fontSize={["text.primaryMobile", "text.primary"]}
      lineHeight="primary"
      p="70px 20px"
    >
      <Element m="0 auto" maxWidth="contentWidth">
        <Element fontSize="text.eyebrow" mb={["30px", "40px"]}>
          {eyebrow}
        </Element>
        <PrismicRichText render={wysiwyg.richText} />
      </Element>
    </StyledSingleColumn>
  )
}

export default SingleColumn
